import { defineStyle } from '@chakra-ui/react';

export const positionPickerVariant = defineStyle({
  border: '2px solid',
  borderRadius: 0,
  borderColor: 'neutral.black',
  background: 'neutral.800',
  color: 'neutral.300',
  _hover: {
    borderColor: 'skyBlue',
  },
  '&[data-active=true]': {
    borderColor: 'skyBlue',
    color: 'neutral.white',
  },
});
